export enum PronounType {
  MASCULINE = 'Masculine',
  FEMININE = 'Feminine',
  NEUTRAL = 'Neutral',
  CUSTOM = 'Custom'
}
